import React from 'react';
import PropTypes from 'prop-types';

import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { amber, blue, iconGrey, green, grape } from 'lib/css/colors';
import { ProductVerificationStatus } from 'lib/enums/ProductVerificationStatus';

const STATUS_COLORS = {
  [ProductVerificationStatus.VERIFIED]: green,
  [ProductVerificationStatus.PENDING_VERIFICATION]: amber,
  [ProductVerificationStatus.UNVERIFIED]: iconGrey,
  [ProductVerificationStatus.AI_VERIFIED]: blue,
  [ProductVerificationStatus.CLAIMED_VERIFICATION]: grape,
};

function VerificationStatusIcon({ verificationStatus, aiSuggestedVerification, isClaimed }) {
  let displayStatus = verificationStatus;

  if (isClaimed && verificationStatus === ProductVerificationStatus.VERIFIED) {
    displayStatus = ProductVerificationStatus.CLAIMED_VERIFICATION;
  } else if (aiSuggestedVerification && verificationStatus === ProductVerificationStatus.VERIFIED) {
    displayStatus = ProductVerificationStatus.AI_VERIFIED;
  }

  return (
    <OverlayTrigger overlay={<Tooltip>{displayStatus}</Tooltip>}>
      <FontAwesomeIcon
        icon={faCheckCircle}
        color={STATUS_COLORS[displayStatus] || iconGrey}
        size="lg"
      />
    </OverlayTrigger>
  );
}

VerificationStatusIcon.propTypes = {
  verificationStatus: PropTypes.string,
  aiSuggestedVerification: PropTypes.bool,
  isClaimed: PropTypes.bool,
};

export default VerificationStatusIcon;
